import React from 'react';
import { Link } from 'react-router-dom';
import { dateString, formatPhoneNumber } from 'shared/utils';
import { Title } from 'shared/components/abstract/interactables';
import DataTable from 'shared/components/table/DataTable';
import { withSelectorSwitch } from 'shared/components/data-display/editors';
import { searchTenants } from 'shared/api/tenants';
import { getUpgrade, searchUpgrades } from 'shared/api/upgrades';
import { getUnitPath } from 'shared/routes/building';
import {
  formatBuildingUpgrade,
  formatPhysicalAddress,
  formatTenantName,
  formatUnitName,
} from 'shared/utils/formatters';
import { buildingEntity } from 'shared/entityDetails';
import { FilterRedirect } from 'shared/hoc/withFilters';
import { withAsyncSelect } from 'shared/components/data-display/withSelectors';
import { getTenantPath, viewPath } from 'shared/routes/tenant';
import { FILTER_DISPLAY_TYPE } from '../../shared/constants';

const columns = [
  {
    name: 'Name',
    formatter: (row) => <Link to={getTenantPath(row.id)}>{formatTenantName(row)}</Link>,
    orderBy: 'it_firstname',
  },
  {
    name: 'Email',
    jsonKey: 'email',
    orderBy: 'it_email',
  },
  {
    name: 'Phone',
    formatter: (row) => formatPhoneNumber(row.phone),
    orderBy: 'it_phone',
  },
  {
    name: 'Address',
    formatter: (row) => (
      row.building_id
        ? (
          <Link to={getUnitPath(row.building_id, row.unit_id)}>
            {formatPhysicalAddress(row, formatUnitName(row.unit_name))}
          </Link>
        )
        : ''
    ),
    orderBy: 'ip_address1',
  },
  {
    name: 'Last Updated',
    formatter: (row) => dateString(row.updated_at),
    orderBy: 'it_updated',
  },
];

const filters = [
  {
    label: 'Building',
    param: 'building_id',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withAsyncSelect(buildingEntity),
    entity: buildingEntity,
  },
  {
    label: 'More Filters',
    key: 'more-filters',
    type: FILTER_DISPLAY_TYPE.group,
    items: [
      {
        label: 'Subscription',
        param: 'plan_id',
        type: FILTER_DISPLAY_TYPE.control,
        FilterComponent: withAsyncSelect({
          name: 'Subscription',
          getRequest: getUpgrade,
          searchRequest: searchUpgrades,
          getOptionLabel: formatBuildingUpgrade,
        }),
        entity: {
          name: 'Subscription',
          getRequest: getUpgrade,
          getOptionLabel: formatBuildingUpgrade,
        },
      },
    ],
  },
  {
    label: 'Include Archived?',
    param: 'include_archived',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
  {
    label: 'Has Subscription?',
    param: 'has_subscription',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
  {
    label: 'SMS Offers Accepted?',
    param: 'sms_opt_in',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
  {
    label: 'Email Offers Accepted?',
    param: 'email_opt_in',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
];

function getRowClassName(row) {
  return !row.unit_id ? 'archived table-row' : 'table-row';
}

/**
 * @param {Object} props
 * @param {string} props.filterKey - Filter key string
 * @param {string} props.savedFilters - Saved filters string
 * @param {string} props.path - Path string
 */
export default function TenantSearch({
  filterKey,
  savedFilters,
  path,
}) {
  if (!FilterRedirect(path, savedFilters)) {
    return (
      <>
        <Title title="Tenants" titleLink={viewPath} />
        <DataTable
          columns={columns}
          filters={filters}
          filterKey={filterKey}
          getRowClassName={getRowClassName}
          rowId="id"
          searchRequest={searchTenants}
          className="table-height-large"
        />
      </>
    );
  }
}
